// APNB's registered return paths remain stable. The landing transfers the
// unverified arrival signal into one result dialog over Settings; only an
// authorized read of our durable order can establish a payment result.
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useBooleanFlagValue, useStringFlagValue } from '../../hooks/useBooleanFlagValue'
import { useClientFlags } from '../../hooks/useClientFlags'
import { canSeeBilling } from './billingAccess'
import { readPendingCheckout } from './checkoutReturnStore'

export type CheckoutOutcome = 'success' | 'failure'

export default function CheckoutReturnPage({ outcome }: { outcome: CheckoutOutcome }) {
  const { user, isLoading: authLoading } = useAuth()
  const { isLoading: flagsLoading } = useClientFlags()
  const enabled = useBooleanFlagValue('billing_sandbox_enabled', false)
  const audience = useStringFlagValue('billing_audience', 'meta_only')
  const [params] = useSearchParams()
  const navigate = useNavigate()
  useEffect(() => {
    if (authLoading || flagsLoading) return
    if (!enabled || !canSeeBilling(user, undefined, audience)) {
      navigate('/dashboard', { replace: true })
      return
    }
    const orderId = (user?.id ? readPendingCheckout(user.id) : null) ?? (params.get('order') || null)
    navigate('/settings/billing', { replace: true, state: { checkoutResult: { outcome, orderId } } })
  }, [authLoading, flagsLoading, enabled, user, audience, params, outcome, navigate])
  return <div className="min-h-screen bg-background" />
}
